// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2TmYl","amount":"Amount_amount__3RriX","tip":"Amount_tip__3vW36","tipHeader":"Amount_tipHeader__2XJmX","tipsWrap":"Amount_tipsWrap__YIMAo"};